import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Order, OrderManagerService, ValidationProblem, ValidationService } from 'reg-hub-common';
import { BaseHistoricalLienDetailsComponent } from '../base-historical-lien-details.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-historical-sk-lien-details',
    templateUrl: './historical-sk-lien-details.component.html',
    styleUrls: ['./historical-sk-lien-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoricalSKLienDetailsComponent extends BaseHistoricalLienDetailsComponent {
  rinError$ = new BehaviorSubject<string | null | undefined>(null);

  constructor(
    formBuilder: FormBuilder,
    orderManager: OrderManagerService,
    validationService: ValidationService
  ) {
    super(formBuilder, orderManager, validationService);
  }

  override onSaving(): void {
    super.onSaving();
    this.setRin(this.order);
  }

  protected override getOrderToValidate(): Order {
    let order = super.getOrderToValidate();
    this.setRin(order);
    return order;
  }

  public override pushErrors(errors: ValidationProblem[] | undefined): void {
    super.pushErrors(errors);

    this.rinError$.next(errors?.filter(error => error.path.includes('/rin'))?.at(0)?.userFriendlyMessage);
  }

  protected override buildForm(): FormGroup {
    const form = this.formBuilder.group({
      amount: [this.order.lien?.amount],
      customRin: [this.getCustomRinInitialValue()],
      rin: [this.order.lien?.rin],
      trustIndenture: [this.order.lien?.trustIndenture ?? false]
    }) as FormGroup;

    if(this.uiConfiguration.lienDetailsConfiguration?.showRIN) {
      form.addControl('customRin', this.formBuilder.control(this.getCustomRinInitialValue()));
      form.addControl('rin', this.formBuilder.control(this.order.lien?.rin));
    }

    if(this.uiConfiguration.lienDetailsConfiguration?.showTrustIndenture) {
      form.addControl('trustIndenture', this.formBuilder.control(this.order.lien?.trustIndenture ?? false));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showInfinityTerm) {
      form.addControl('isInfiniteTerm', this.formBuilder.control(this.order.lien?.isInfiniteTerm));
    }

    return form;
  }

  private setRin(order: Order) {
    const rinControl = this.lienDetails.get('customRin');

    order.lien!.systemGeneratedRIN = false;

    if(rinControl?.value === 'no') {
      order.lien!.noRIN = true;
      order.lien!.rin = null;
    } else {
      order.lien!.noRIN = false;
      order.lien!.rin = this.lienDetails.get('rin')?.value;
    }
  }

  private getCustomRinInitialValue(): string {
    if (this.order.lien?.rin || this.order.lien?.rin === '') {
      return 'choose';
    } else {
      return 'no';
    }
  }
}